import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'

import Icon from '../../../Icons'

const MediaUpload = ({ config, onNext, onBack, editMode }) => {
  const { t } = useTranslation(['create-event', 'common'])
  return (
    <div className="event-content">
      <div className="inputs-wrapper">
        <div className="event-header">{config.header}</div>
        <div className="input-row">
          <div className="input-container">
            <div className="input-label">{config.inputs.first.label}</div>
            {config.inputs.first.render()}
          </div>
        </div>
        {config.inputs.second && (
          <div className="input-row">
            <div className="input-container">
              <div className="input-label">
                {config.inputs.second.labelIcon && (
                  <Icon
                    styles={{ width: '20px', height: '20px' }}
                    fill="none"
                    svgProps={{ stroke: 'black' }}
                    icon={config.inputs.second.labelIcon}
                  />
                )}
                {config.inputs.second.label}
              </div>
              {config.inputs.second && config.inputs.second.render()}
            </div>
          </div>
        )}
      </div>
      {!editMode && (
        <div className="event-footer">
          <button className="button button-grey" onClick={onBack}>
            {t('common:actions.back')}
          </button>
          <button className="button button-primary" disabled={!config.canGoNext} onClick={onNext}>
            {t('create-event:shared.next')}
          </button>
        </div>
      )}
    </div>
  )
}

MediaUpload.propTypes = {
  config: PropTypes.object,
  onNext: PropTypes.func,
  onBack: PropTypes.func,
  editMode: PropTypes.bool,
}

export default MediaUpload
